<nav class="navbar navbar-expand-lg fixed-top">
  <a class="navbar-brand" routerLink="/">
    <img class="logo" src="./assets/images/logo_new.png" />
  </a>
  <span class="logo-span">{{ sitename }}</span>
  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav ms-auto">
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>PLANT SETTINGS <i class="fa fa-angle-down"></i></a>
        <ul ngbDropdownMenu>
          <li class="nav-item" ngbDropdown>
            <a ngbDropdownItem routerLink="/site/allsiteuser"> USER </a>
          </li>
          <li *ngIf="['2'].includes(user.role)" class="nav-item" ngbDropdown>
            <a ngbDropdownItem href="javascript:void(0)" (click)="onPlantCustomizationClick()">PLANT CUSTOMIZATION</a>
          </li>
          <!-- <li *ngIf="['2'].includes(user.role)" class="nav-item" ngbDropdown><a ngbDropdownItem [routerLink]="['/site/editsite', allocatedSite]">PLANT CUSTOMIZATION</a></li> -->
          <!-- <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>ALERTS <i class="fa fa-caret-right"></i></a>
            <ul ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/alerts/pmalerts"> PM ALERTS</a>
              <a ngbDropdownItem routerLink="/alerts/modulealerts">
                MODULE ALERTS</a>
              <a ngbDropdownItem routerLink="/alerts/parameteralerts">
                PARAMETERS ALERTS</a>
            </ul>
          </li> -->
          <li class="nav-item">
            <a class="sub-dropdown" routerLink="/newalerts/alertlist" [queryParams]="{ showTableOnly: false }"
              ngbDropdownItem>ADVANCED ALERTS</a>
          </li>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>
              SINGLE REPORT <i class="fa fa-caret-right"></i></a>
            <ul ngbDropdownMenu class="submenu-right">
              <li>
                <a ngbDropdownItem routerLink="/report-system/report-list/process">PROCESS</a>
              </li>
              <li>
                <a ngbDropdownItem routerLink="/report-system/report-list/opex">OPEX</a>
              </li>
            </ul>
          </li>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>
              SINGLE REPORT (OLD) <i class="fa fa-caret-right"></i></a>
            <ul ngbDropdownMenu class="submenu-right">
              <li>
                <a ngbDropdownItem routerLink="/reportlibrary/editreport/process">PROCESS</a>
              </li>
              <li>
                <a ngbDropdownItem routerLink="/reportlibrary/editreport/opex">OPEX</a>
              </li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <a ngbDropdownItem routerLink="/equipment/equipmentsetting">EQUIPMENT</a>
          </li>
          <li ngbDropdown class="dropdown-submenu" *ngIf="['2', '11'].includes(user?.role)">
            <a class="sub-dropdown" ngbDropdownToggle>MANUAL DATA UPLOAD <i class="fa fa-caret-right"></i></a>
            <div ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/uploadagent/managelab">
                MANAGE MANUAL DATA UPLOAD</a>
              <a ngbDropdownItem routerLink="/uploadagent/managelabusers">
                MANAGE USERS</a>
            </div>
          </li>
          <!-- <li class="nav-item">
            <a class="sub-dropdown" routerLink="/newalerts/alertlist" [queryParams]="{ showTableOnly: false }"
              ngbDropdownItem>ADVANCED ALERTS</a>
          </li> -->
          <li class="nav-item">
            <a class="sub-dropdown" href="javascript:void(0)" (click)="onDmsUserSettingClick()"
              ngbDropdownItem>DMS USER SETTING</a>
          </li>
        </ul>
      </li>
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>REPORTS <i class="fa fa-angle-down"></i></a>
        <ul ngbDropdownMenu>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>PROCESS <i class="fa fa-caret-right"></i></a>
            <div ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/dashboard/processdashboard">MODULE</a>
              <a ngbDropdownItem routerLink="/report-system/report-list/process">
                LIST
              </a>
            </div>
          </li>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>OPEX <i class="fa fa-caret-right"></i></a>
            <div ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/report-system/module-reports/opex">
                MODULE</a>
              <a ngbDropdownItem routerLink="/report-system/report-list/opex">
                LIST
              </a>
            </div>
          </li>
        </ul>
      </li>
       <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>REPORTS (OLD) <i class="fa fa-angle-down"></i></a>
        <ul ngbDropdownMenu>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>PROCESS <i class="fa fa-caret-right"></i></a>
            <div ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/dashboard/processdashboard">MODULE</a>
              <a ngbDropdownItem routerLink="/reportlibrary/editreport/process">
                LIST
              </a>
            </div>
          </li>
          <li ngbDropdown class="dropdown-submenu">
            <a class="sub-dropdown" ngbDropdownToggle>OPEX <i class="fa fa-caret-right"></i></a>
            <div ngbDropdownMenu class="submenu-right">
              <a ngbDropdownItem routerLink="/dashboard/opexdashboard">
                MODULE</a>
              <a ngbDropdownItem routerLink="/reportlibrary/editreport/opex">
                LIST
              </a>
            </div>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/report-system/dashboard-group-list">SPECIAL REPORTS</a>
      </li>
       <li class="nav-item">
        <a class="nav-link" routerLink="/mixdashboard/mix-report-list">SPECIAL REPORTS (OLD)</a>
      </li>
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" routerLink="/newalerts/alertlist" [queryParams]="{ showTableOnly: true }">ALERTS
        </a>
        <!-- <a class="nav-link" ngbDropdownToggle>ALERTS <i class="fa fa-angle-down"></i></a>
        <ul ngbDropdownMenu>
          <li>
            <a class="sub-dropdown" routerLink="/alerts/openalert">OPEN</a>
          </li>
          <li>
            <a class="sub-dropdown" routerLink="/alerts/historyalert"
              >HISTORY</a
            >
          </li>
        </ul> -->
      </li>
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>DATA UPLOAD <i class="fa fa-angle-down"></i></a>
        <ul ngbDropdownMenu>
          <li>
            <a class="sub-dropdown" routerLink="/site/uploads/process">PROCESS</a>
          </li>
          <li>
            <a class="sub-dropdown" routerLink="/site/uploads/opex">OPEX</a>
          </li>
          <li>
            <a class="sub-dropdown" routerLink="/site/dynamic-opex-pricing-list">SPECIAL LUT</a>
          </li>
          <li>
            <a class="sub-dropdown" routerLink="/uploadagent/managelabupload">MANUAL UPLOAD APP</a>
          </li>
          <li class="nav-item">
            <a class="sub-dropdown" href="javascript:void(0)" (click)="onDmsClick()"
              ngbDropdownItem>DMS</a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="
          siteinfo &&
          siteinfo[0].sitepfd &&
          ['2', '3', '7', '11', '8', '9', '15'].includes(user?.role)
        ">
        <a class="nav-link" routerLink="/site/pdfviewer">PFD</a>
      </li>
      <li class="nav-item notification-nav-item" *ngIf="['2', '3', '7', '11', '8', '9', '15'].includes(user?.role)">
        <a class="nav-link notification-link" (click)="toggleNotificationPanel()" title="Notifications" style="cursor: pointer;">
          <i class="fa fa-bell notification-icon"></i>
          <span *ngIf="unreadNotificationCount > 0" class="notification-badge">{{ unreadNotificationCount }}</span>
        </a>
      </li>
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>
          <img [src]="imageSrc || './assets/images/avathar.jpg'" class="avatar" alt="User avatar" />
        </a>
        <ul ngbDropdownMenu class="lgn-btn">
          <li>
            <a class="sub-dropdown-lgn" (click)="logout()" *ngIf="!visitedUserManagementSites"><i
                class="fa fa-power-off"></i> Logout
            </a>
            <span *ngIf="visitedUserManagementSites" class="sub-dropdown-lgn text-muted"
              style="cursor:not-allowed;user-select:none; margin-right: 80px; padding-left: 2px;">
              <i class="fa fa-ban"></i> You can't <br>logout from here
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- Notification Panel Backdrop -->
<div 
  *ngIf="isNotificationPanelOpen" 
  class="notification-backdrop"
  (click)="onBackdropClick($event)">
</div>

<!-- Notification Panel -->
<div 
  class="notification-panel"
  [class.open]="isNotificationPanelOpen"
  [class.dark-mode]="notificationListComponent?.isDarkMode">
  <div class="notification-panel-header">
    <h4 class="notification-panel-title">
      <i class="fa fa-bell"></i> Notifications
      <span *ngIf="unreadNotificationCount > 0" class="badge badge-danger unread-badge-panel">
        {{ unreadNotificationCount }}
      </span>
    </h4>
    <div class="notification-panel-actions">
      <div class="theme-switch-container">
        <label class="theme-switch-label">
          <i class="fa fa-sun" [class.active]="!notificationListComponent?.isDarkMode"></i>
          <input 
            type="checkbox" 
            class="theme-switch"
            [checked]="notificationListComponent?.isDarkMode"
            (change)="notificationListComponent?.toggleTheme()"
            title="Toggle Dark/Light Mode">
          <span class="theme-switch-slider"></span>
          <i class="fa fa-moon" [class.active]="notificationListComponent?.isDarkMode"></i>
        </label>
      </div>
      <button class="btn btn-sm btn-close-panel" (click)="closeNotificationPanel()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="notification-panel-content">
    <app-notification-list 
      #notificationListComponent
      [class.dark-mode]="notificationListComponent?.isDarkMode"
      (notificationClicked)="closeNotificationPanel()">
    </app-notification-list>
  </div>
</div>

<!-- Site Edit Status Dialog -->
<ng-template #siteEditStatusDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title">INFO</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p><i class="fa fa-info-circle" aria-hidden="true"></i> &nbsp; Site Settings saving under progress, please try after its completed</p>
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary" (click)="navigateToHome(modal)">Home</button> -->
  </div>
</ng-template>